import React from 'react';
import PropTypes from 'prop-types';
import MarketoForm from '../../MarketoForm/MarketoForm';

const ArticleFooter = ({ type }) => (
  <div className={`newsletter__widget newsletter__widget__${type}`}>
    <header>
      <img
        alt="Fast Company logo with black background and white lettering"
        className="header__logo"
        src="https://images.fastcompany.net/image/upload/v1663873385/fcweb/fc_bug_j9tlov.svg"
      />
      <div>
        <span className="highlight">Be in the Know.</span>&nbsp;Subscribe to
        Fast Company Newsletters.
      </div>
    </header>
    <MarketoForm assetId={1040} btnId="formSubmittee" />
    <div className="customSubmit">
      <button id="formSubmittee">SUBMIT</button>
      <a href="https://www.fastcompany.com/newsletters">
        Learn more about our newsletters
      </a>
    </div>
    <footer>
      <a
        rel="noopener noreferrer"
        href="https://www.mansueto.com/privacy-policy/"
        target="_blank"
      >
        Privacy Policy
      </a>
    </footer>
  </div>
);

ArticleFooter.displayName = 'ArticleFooter';

ArticleFooter.propTypes = {
  type: PropTypes.string.isRequired
};

export default ArticleFooter;
